export const movies = [
  {
    id: "m001",
    title: "雨夜迷踪",
    year: 2025,
    genre: "悬疑",
    region: "中国",
    director: "陈默安",
    cast: "林知远 / 沈夏 / 周慕之",
    duration: 118,
    heat: 9860,
    releaseDate: "2025-08-14",
    tags: ["悬疑", "雨夜", "都市"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20midnight%20movie%20poster%20artwork%20of%20a%20rain-soaked%20narrow%20alley%20with%20a%20lone%20silhouette%20holding%20an%20umbrella%20under%20flickering%20neon%20signage%2C%20deep%20navy%20and%20charcoal%20color%20palette%20with%20a%20warm%20amber%20rim%20light%2C%20wet%20reflective%20asphalt%2C%20cinematic%20film%20grain%2C%20moody%20midnight%20atmosphere%2C%20no%20text%20and%20no%20lettering%2C%20elegant%20editorial%20poster%20composition&width=600&height=900&seq=movie-poster-01&orientation=portrait",
    synopsis: "一场持续整夜的暴雨，把城市最旧的街区冲成一座孤岛。值夜班的记录员在便利店门口捡到一盘被雨水泡过的磁带，里面反复出现同一个女人的求救声。她循着声音走进街区深处，发现每一个擦肩而过的人，都记得同一个不属于自己的夜晚。",
  },
  {
    id: "m002",
    title: "霓虹尽头",
    year: 2025,
    genre: "犯罪",
    region: "中国",
    director: "高野",
    cast: "苏执 / 何清 / 罗砚",
    duration: 124,
    heat: 9724,
    releaseDate: "2025-09-02",
    tags: ["犯罪", "霓虹", "追凶"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20midnight%20crime%20film%20poster%20of%20a%20lone%20detective%20standing%20on%20a%20wet%20rooftop%20overlooking%20a%20glowing%20neon%20city%20skyline%2C%20deep%20midnight%20blue%20haze%20with%20warm%20orange%20highlights%2C%20dense%20fog%20and%20light%20streaks%2C%20dramatic%20backlight%20silhouette%2C%20fine%20film%20grain%2C%20moody%20noir%20atmosphere%2C%20no%20text%20and%20no%20lettering%2C%20high%20detail%20editorial%20artwork&width=600&height=900&seq=movie-poster-02&orientation=portrait",
    synopsis: "霓虹灯牌一块一块熄灭的深夜，刑警队长接到一通没有声音的报警电话。线索指向城市边缘一条即将拆除的商业街，那里住着二十年前一桩旧案的所有证人。当最后一块灯牌熄灭，他终于看清了那个一直站在光外的人。",
  },
  {
    id: "m003",
    title: "第七号放映厅",
    year: 2024,
    genre: "恐怖",
    region: "欧美",
    director: "埃利亚斯·凡恩",
    cast: "玛拉·金 / 卢卡斯·雷 / 诺亚·费恩",
    duration: 106,
    heat: 9512,
    releaseDate: "2024-10-31",
    tags: ["恐怖", "影院", "超自然"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20horror%20movie%20poster%20of%20an%20abandoned%20vintage%20cinema%20hall%20with%20rows%20of%20dark%20red%20velvet%20seats%20and%20a%20single%20dusty%20projector%20beam%20cutting%20through%20the%20darkness%2C%20deep%20navy%20shadows%20with%20amber%20light%2C%20floating%20dust%20particles%2C%20unsettling%20symmetrical%20composition%2C%20film%20grain%2C%20no%20text%20and%20no%20lettering%2C%20atmospheric%20midnight%20artwork&width=600&height=900&seq=movie-poster-03&orientation=portrait",
    synopsis: "老影院重新开业的第一晚，第七号放映厅的门票在开场前半小时售空。散场后工作人员发现，厅内座椅上落满了几十年的灰尘，没有一个脚印。而监控里，那场电影始终在同一个镜头反复播放，座位上坐满了看不清面孔的人。",
  },
  {
    id: "m004",
    title: "深蓝回声",
    year: 2025,
    genre: "科幻",
    region: "欧美",
    director: "娜奥米·卡特",
    cast: "伊恩·罗素 / 艾薇·诺兰 / 提姆·哈尔",
    duration: 132,
    heat: 9388,
    releaseDate: "2025-07-19",
    tags: ["科幻", "深海", "孤独"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20poster%20of%20a%20submerged%20research%20station%20glowing%20at%20the%20bottom%20of%20a%20deep%20dark%20ocean%2C%20a%20circular%20illuminated%20window%20casting%20pale%20cyan%20light%20into%20deep%20navy%20water%2C%20suspended%20particles%20and%20slow%20bubbles%2C%20cold%20blue%20tones%20with%20a%20warm%20amber%20interior%20glow%2C%20film%20grain%2C%20mysterious%20midnight%20mood%2C%20no%20text%20and%20no%20lettering&width=600&height=900&seq=movie-poster-04&orientation=portrait",
    synopsis: "海底四千米的观测站只剩下一名值守员和一台会说话的声呐。某天，声呐开始重复一段不属于任何已知语言的回声，节奏与地球上的雨声完全一致。为了确认这段声音的来源，她打开了那扇已经封存十一年舱门。",
  },
  {
    id: "m005",
    title: "凌晨四点的出租车",
    year: 2024,
    genre: "剧情",
    region: "日韩",
    director: "森川遥",
    cast: "木下真理 / 佐野航 / 田村绫",
    duration: 112,
    heat: 9105,
    releaseDate: "2024-11-08",
    tags: ["剧情", "都市", "温情"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20seen%20from%20inside%20a%20taxi%20at%20night%2C%20glowing%20dashboard%20lights%20and%20rain%20droplets%20on%20the%20windshield%20framing%20an%20empty%20city%20street%20with%20distant%20amber%20street%20lamps%2C%20deep%20navy%20and%20charcoal%20tones%2C%20soft%20bokeh%20reflections%2C%20quiet%20lonely%20atmosphere%2C%20fine%20film%20grain%2C%20no%20text%20and%20no%20lettering%2C%20editorial%20film%20artwork&width=600&height=900&seq=movie-poster-05&orientation=portrait",
    synopsis: "开夜班出租的老司机有一条规矩：凌晨四点以后不载醉客。直到某个雨夜，一个抱着旧收音机的女孩上了车，说要去城市另一头早已停业的电台。这一趟没有打表的路程，把他二十年没讲完的故事一节一节接了回去。",
  },
  {
    id: "m006",
    title: "月光下的信",
    year: 2023,
    genre: "爱情",
    region: "中国",
    director: "叶青禾",
    cast: "顾以宁 / 江迟 / 温亭",
    duration: 108,
    heat: 8874,
    releaseDate: "2023-06-16",
    tags: ["爱情", "书信", "旧城"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20film%20poster%20of%20a%20moonlit%20old%20balcony%20with%20handwritten%20letters%20scattered%20on%20a%20wooden%20table%2C%20pale%20blue%20moonlight%20and%20warm%20lamp%20glow%2C%20sheer%20curtains%20drifting%20in%20a%20night%20breeze%2C%20deep%20navy%20background%20with%20silver%20highlights%2C%20delicate%20film%20grain%2C%20quietly%20emotional%20midnight%20mood%2C%20no%20text%20and%20no%20lettering&width=600&height=900&seq=movie-poster-06&orientation=portrait",
    synopsis: "旧城改造前的最后一个夏天，两个从未见过面的笔友约在月光码头见面。可当晚来的只有一个人，和一只装着十年信件的铁盒。她坐在台阶上读完最后一封，才发现每一封信的落款日期，都比寄出日期晚了一年。",
  },
  {
    id: "m007",
    title: "无声警报",
    year: 2025,
    genre: "动作",
    region: "港台",
    director: "麦子朗",
    cast: "程骁 / 阮静川 / 高柏",
    duration: 121,
    heat: 9256,
    releaseDate: "2025-05-23",
    tags: ["动作", "码头", "营救"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20action%20film%20poster%20of%20a%20lone%20figure%20in%20a%20dark%20coat%20walking%20through%20an%20industrial%20container%20dock%20at%20midnight%2C%20orange%20sparks%20and%20cranes%20silhouetted%20against%20deep%20navy%20fog%2C%20dramatic%20backlight%20and%20strong%20contrast%2C%20motion%20blur%20of%20rain%2C%20film%20grain%2C%20tense%20atmospheric%20composition%2C%20no%20text%20and%20no%20lettering&width=600&height=900&seq=movie-poster-07&orientation=portrait",
    synopsis: "港口的警报系统在凌晨两点整被关闭，七分钟后重新启动，没有人知道那七分钟里发生了什么。前拆弹手被迫回到他离开多年的码头，在成排集装箱之间寻找一个从不发出声音的装置，也寻找那个熟悉得让他不敢回头的身影。",
  },
  {
    id: "m008",
    title: "雪原列车",
    year: 2022,
    genre: "悬疑",
    region: "日韩",
    director: "北村凌",
    cast: "井上沙耶 / 松冈京 / 高桥隼",
    duration: 116,
    heat: 8740,
    releaseDate: "2022-12-09",
    tags: ["悬疑", "雪夜", "列车"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20poster%20of%20an%20old%20night%20train%20cutting%20through%20a%20vast%20snowy%20forest%2C%20warm%20glowing%20windows%20against%20deep%20navy%20darkness%2C%20snowflakes%20drifting%20in%20the%20beam%20of%20the%20locomotive%2C%20lonely%20atmospheric%20composition%2C%20cool%20blue%20and%20amber%20contrast%2C%20fine%20film%20grain%2C%20no%20text%20and%20no%20lettering%2C%20high%20detail%20winter%20artwork&width=600&height=900&seq=movie-poster-08&orientation=portrait",
    synopsis: "一列因暴雪停驶的夜行列车，十二名乘客，一个空着的铺位。列车长每隔一小时清点一次人数，数字始终对不上。当雪停下来，所有人都不记得自己为什么要上这趟车，只有车窗外那座早已废弃的小站，亮着一盏为谁留的灯。",
  },
  {
    id: "m009",
    title: "午夜理发店",
    year: 2024,
    genre: "恐怖",
    region: "中国",
    director: "宋照",
    cast: "陆知 / 白颜 / 何东",
    duration: 97,
    heat: 8612,
    releaseDate: "2024-09-27",
    tags: ["恐怖", "理发店", "循环"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20horror%20poster%20of%20a%20vintage%20barbershop%20at%20midnight%20with%20a%20single%20empty%20leather%20chair%20facing%20a%20large%20mirror%2C%20one%20warm%20bulb%20buzzing%20in%20deep%20navy%20darkness%2C%20hair%20clippings%20on%20the%20floor%20and%20pale%20reflections%2C%20unsettling%20stillness%2C%20film%20grain%2C%20moody%20amber%20and%20charcoal%20tones%2C%20no%20text%20and%20no%20lettering&width=600&height=900&seq=movie-poster-09&orientation=portrait",
    synopsis: "巷子口的理发店只在凌晨一点开门，招牌上写着“剪去不该留的”。加班到深夜的上班族推门进去，只想修一修刘海。镜子里的人比他先坐下，也比他先开口：这次想剪掉哪一段记忆？",
  },
  {
    id: "m010",
    title: "城市最后一盏灯",
    year: 2023,
    genre: "剧情",
    region: "欧美",
    director: "克拉拉·维恩",
    cast: "艾登·科尔 / 露西·梅 / 奥托·兰",
    duration: 105,
    heat: 8341,
    releaseDate: "2023-03-10",
    tags: ["剧情", "城市", "孤独"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20of%20a%20single%20glowing%20window%20in%20a%20massive%20dark%20apartment%20building%20at%20midnight%2C%20deep%20navy%20facade%20with%20subtle%20window%20grids%2C%20warm%20amber%20light%20spilling%20onto%20a%20fire%20escape%2C%20snow%20falling%20softly%2C%20lonely%20urban%20atmosphere%2C%20fine%20film%20grain%2C%20minimal%20elegant%20composition%2C%20no%20text%20and%20no%20lettering&width=600&height=900&seq=movie-poster-10&orientation=portrait",
    synopsis: "整栋楼只剩他这一户还亮着灯。白天他在写字楼里替别人关灯，夜里回到空荡荡的家，习惯性地打开所有的灯。直到某个停电的凌晨，他第一次听见对面楼里传来同样孤单的钢琴声。",
  },
  {
    id: "m011",
    title: "逆光追踪",
    year: 2022,
    genre: "动作",
    region: "欧美",
    director: "马库斯·雷德",
    cast: "迪恩·哈珀 / 索菲亚·凯 / 里奥·唐",
    duration: 110,
    heat: 8190,
    releaseDate: "2022-08-19",
    tags: ["动作", "追车", "隧道"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20action%20poster%20of%20a%20car%20speeding%20through%20a%20long%20midnight%20tunnel%2C%20strong%20backlight%20flare%20and%20long%20light%20streaks%2C%20deep%20navy%20darkness%20with%20intense%20amber%20headlights%2C%20wet%20asphalt%20reflections%2C%20dramatic%20motion%20blur%2C%20fine%20film%20grain%2C%20high%20contrast%20cinematic%20composition%2C%20no%20text%20and%20no%20lettering&width=600&height=900&seq=movie-poster-11&orientation=portrait",
    synopsis: "一场发生在环城隧道里的追逐，让两名素不相识的司机成了彼此唯一的证人。他们都记得前方那辆车没有车牌，也都记得隧道尽头没有出口。天亮之前，他们必须决定谁先说出真相。",
  },
  {
    id: "m012",
    title: "海边的第二封信",
    year: 2021,
    genre: "爱情",
    region: "日韩",
    director: "长谷川澪",
    cast: "宫本千寻 / 大野悠 / 铃木茜",
    duration: 103,
    heat: 7988,
    releaseDate: "2021-07-02",
    tags: ["爱情", "海边", "重逢"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20poster%20of%20a%20quiet%20seaside%20at%20midnight%2C%20a%20distant%20lighthouse%20beam%20sweeping%20across%20dark%20navy%20water%2C%20a%20small%20wooden%20mailbox%20on%20a%20weathered%20pier%20with%20warm%20lantern%20light%2C%20gentle%20waves%20and%20sea%20mist%2C%20soft%20amber%20and%20silver%20blue%20tones%2C%20film%20grain%2C%20tender%20nostalgic%20mood%2C%20no%20text%20and%20no%20lettering&width=600&height=900&seq=movie-poster-12&orientation=portrait",
    synopsis: "海边小镇的邮局每年夏天都会收到一封寄不出去的信，收件人写着“明天的我”。新来的邮差决定把信送到，却发现写信的人每年都在同一个礁石上等着一个不会来的人，而那个人，恰好是她自己。",
  },
  {
    id: "m013",
    title: "雾港旧案",
    year: 2020,
    genre: "犯罪",
    region: "港台",
    director: "霍家朗",
    cast: "郑叙 / 曾岚 / 罗启",
    duration: 127,
    heat: 7860,
    releaseDate: "2020-10-15",
    tags: ["犯罪", "港口", "旧案"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20poster%20of%20a%20foggy%20harbor%20at%20midnight%20with%20stacked%20cargo%20containers%20and%20a%20single%20amber%20dock%20lamp%2C%20silhouette%20of%20a%20man%20in%20a%20long%20coat%20walking%20away%2C%20deep%20navy%20mist%20and%20silver%20highlights%2C%20wet%20concrete%20reflections%2C%20film%20grain%2C%20moody%20noir%20atmosphere%2C%20no%20text%20and%20no%20lettering&width=600&height=900&seq=movie-poster-13&orientation=portrait",
    synopsis: "港口档案室的一场小火，烧掉了一整年的卷宗。退休多年的老警探回到雾港，只带着一张模糊的照片和一个编号。他要在潮水退去之前，把十九年前那桩没写完的结案报告补上最后一个名字。",
  },
  {
    id: "m014",
    title: "星际邮差",
    year: 2021,
    genre: "科幻",
    region: "中国",
    director: "沈聿",
    cast: "何为 / 姜予 / 白岑",
    duration: 125,
    heat: 8244,
    releaseDate: "2021-11-26",
    tags: ["科幻", "星际", "温情"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20poster%20of%20a%20small%20weathered%20spacecraft%20flying%20low%20over%20a%20dark%20desert%20planet%20at%20midnight%2C%20glowing%20amber%20engine%20trail%20and%20deep%20navy%20star%20field%2C%20distant%20ringed%20planet%2C%20drifting%20dust%2C%20lonely%20adventurous%20atmosphere%2C%20fine%20film%20grain%2C%20no%20text%20and%20no%20lettering%2C%20detailed%20editorial%20artwork&width=600&height=900&seq=movie-poster-14&orientation=portrait",
    synopsis: "星际邮路开通的第三十年，最后一位人类邮差接到了他的最后一单。收件地址是一颗早已撤离的殖民星，收件人写着一个二十年前的名字。他带着一整舱没人认领的信，飞向那片没有回信的天空。",
  },
  {
    id: "m015",
    title: "无人接听",
    year: 2025,
    genre: "悬疑",
    region: "欧美",
    director: "朱利安·贝克",
    cast: "卡拉·西蒙 / 文森·李 / 艾拉·摩",
    duration: 101,
    heat: 9042,
    releaseDate: "2025-02-28",
    tags: ["悬疑", "电话亭", "时间"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20poster%20of%20a%20lone%20telephone%20booth%20glowing%20in%20an%20empty%20parking%20lot%20at%20midnight%2C%20deep%20navy%20sky%20and%20wet%20asphalt%20reflections%2C%20hanging%20receiver%20and%20scattered%20papers%2C%20cold%20blue%20tones%20with%20warm%20amber%20booth%20light%2C%20unsettling%20quiet%2C%20film%20grain%2C%20no%20text%20and%20no%20lettering&width=600&height=900&seq=movie-poster-15&orientation=portrait",
    synopsis: "停车场角落的电话亭每晚会响三次，接起来只有一段忙音。值夜的保安开始记录每次响铃的时间，发现它们精确对应着这座城市未来三天里将要发生的意外。第三次响铃时，他听见了自己的声音。",
  },
  {
    id: "m016",
    title: "长夜将尽",
    year: 2015,
    genre: "剧情",
    region: "中国",
    director: "章叙白",
    cast: "罗开山 / 沈玉 / 陈望",
    duration: 134,
    heat: 7620,
    releaseDate: "2015-04-18",
    tags: ["剧情", "经典", "人生"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20classic%20drama%20poster%20of%20a%20lonely%20figure%20standing%20on%20a%20rooftop%20at%20the%20edge%20of%20dawn%2C%20deep%20navy%20night%20sky%20fading%20into%20pale%20silver%20horizon%2C%20distant%20city%20silhouettes%20and%20thin%20morning%20mist%2C%20warm%20amber%20street%20lights%20below%2C%20fine%20film%20grain%2C%20quiet%20contemplative%20composition%2C%20no%20text%20and%20no%20lettering&width=600&height=900&seq=movie-poster-16&orientation=portrait",
    synopsis: "在天台守了二十年的看夜人，第一次决定在天亮之前离开。他把钥匙、手电和一整本写满名字的笔记交给新来的年轻人，然后沿着没有路灯的那条街慢慢走下去，走进他躲了半生的清晨。",
  },
  {
    id: "m017",
    title: "黑胶时代",
    year: 2012,
    genre: "剧情",
    region: "港台",
    director: "梁伯言",
    cast: "方启 / 苏眉 / 何家安",
    duration: 119,
    heat: 7412,
    releaseDate: "2012-09-21",
    tags: ["剧情", "经典", "音乐"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20nostalgic%20poster%20of%20a%20dim%20vintage%20record%20store%20at%20midnight%2C%20shelves%20of%20vinyl%20records%20and%20a%20single%20warm%20desk%20lamp%2C%20deep%20navy%20shadows%20with%20amber%20highlights%2C%20dust%20in%20the%20air%2C%20an%20old%20turntable%20spinning%2C%20fine%20film%20grain%2C%20intimate%20analog%20atmosphere%2C%20no%20text%20and%20no%20lettering&width=600&height=900&seq=movie-poster-17&orientation=portrait",
    synopsis: "唱片行关门前最后一夜，老板把店里最后一张黑胶放到唱机上。常来的老顾客、隔壁面馆的老板娘、还有那个总在门口徘徊的少年，都听见了同一段旋律，那是他们各自人生里最想重来一次的三分钟。",
  },
  {
    id: "m018",
    title: "白色走廊",
    year: 2023,
    genre: "恐怖",
    region: "日韩",
    director: "石井真吾",
    cast: "小林遥 / 中村圭 / 森下玲",
    duration: 99,
    heat: 8530,
    releaseDate: "2023-10-13",
    tags: ["恐怖", "医院", "长镜"],
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20horror%20poster%20of%20an%20endless%20white%20hospital%20corridor%20at%20midnight%20with%20flickering%20fluorescent%20lights%2C%20deep%20navy%20shadows%20at%20the%20far%20end%2C%20one%20wheelchair%20and%20a%20fallen%20file%2C%20cold%20clean%20surfaces%20with%20subtle%20amber%20spill%2C%20unsettling%20perspective%2C%20fine%20film%20grain%2C%20no%20text%20and%20no%20lettering&width=600&height=900&seq=movie-poster-18&orientation=portrait",
    synopsis: "值夜班的护士发现，三楼的走廊每到凌晨三点就会多出一扇门。门后是同样的走廊，同样的灯，同样推着药物车向前走的自己。她数过，走到第十一次的时候，那扇门就再也不会关上了。",
  },
];